/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import config from "../../../config";
import axiosClient from "../../../_helpers/http.helper";
import ModalDialog from "../../widgets/ModalDialog/ModalDialog";
import { TEXT_TYPES } from '../../../constants/APP_CONSTANTS';

export default class PriceUpdate extends React.Component {

    state = {
        updatedPrice : {
            price : {name : "Asset Price", value: null},
            priceCanada : {name : "Asset Price Canada", value: null},
            overridePrice: {name : "Override Price", value: null},
            overridePriceCanada: {name : "Override Price Canada", value: null},
        },
        isConfirmationModalActive: false,
        isBatchCompleteModalActive: false
    };

    onPriceEdit = (id, value) => {
        this.setState(prevState => ({
            updatedPrice: {
                ...prevState.updatedPrice,
                [id]: {
                    ...prevState.updatedPrice[id],
                    value: value
                }
            }
        }));
    };

    validatePrice(e){
        if (['e', 'E', '-', '+'].includes(e.key)) {
            e.preventDefault();
        }
    }

    updateResourcePrice = () => {
        const priceUpdateRoute
            = config.contentService.baseUrl
            + config.contentService.routes.updatePriceByResourceIds;

        const requestBody = {
            "resourceIds":this.props.selectedResources,
            "price": this.state.updatedPrice.price.value,
            "priceCanada": this.state.updatedPrice.priceCanada.value,
            "overridePrice": this.state.updatedPrice.overridePrice.value,
            "overridePriceCanada": this.state.updatedPrice.overridePriceCanada.value
        };

        axiosClient.post(priceUpdateRoute, requestBody)
            .then(response => {
                this.setState({
                    isConfirmationModalActive: false,
                    isBatchCompleteModalActive: true,
                    batchId: response.data
                });
            }

            );
    };

    render() {
        return (
            <div className="price_update">
                <div className="asset-price">
                    <h4>Edit digital price</h4>
                    <div>
                        <label>Asset Price</label>
                        <input className="pe-textInput--basic" id ="price" type="number" min={0}
                            onChange={e => this.onPriceEdit(e.target.id, e.target.value)}
                            value={this.state.updatedPrice.price.value} onKeyPress={this.validatePrice}/>
                    </div>
                    <div>
                        <label>Asset Price Canada</label>
                        <input className="pe-textInput--basic" id ="priceCanada" type="number" min={0}
                            onChange={e => this.onPriceEdit(e.target.id, e.target.value)}
                            value={this.state.updatedPrice.priceCanada.value} onKeyPress={this.validatePrice}/>
                    </div>
                </div>
                <div className="override-price">
                    <h4>Print price override</h4>
                    <div>
                        <label>Price</label>
                        <input className="pe-textInput--basic" id ="overridePrice" type="number" min={0}
                            onChange={e => this.onPriceEdit(e.target.id, e.target.value)}
                            value={this.state.updatedPrice.overridePrice.value} onKeyPress={this.validatePrice}/>
                    </div>
                    <div>
                        <label>Price Canada</label>
                        <input className="pe-textInput--basic" id ="overridePriceCanada" type="number" min={0}
                            onChange={e => this.onPriceEdit(e.target.id, e.target.value)}
                            value={this.state.updatedPrice.overridePriceCanada.value} onKeyPress={this.validatePrice}/>
                    </div>
                    <div className="submit">
                        <input  className="pe-btn__primary" type="button" value="Submit"
                            onClick={() => {
                                if( this.state.updatedPrice.price.value || this.state.updatedPrice.priceCanada.value
                                    || this.state.updatedPrice.overridePrice.value
                                    || this.state.updatedPrice.overridePriceCanada.value) {
                                    this.setState({
                                        isConfirmationModalActive: true
                                    });
                                } else {
                                    alert("Atleast 1 price value required!!!");
                                }
                            }
                            }/>
                    </div>
                </div>
                <ModalDialog
                    title="Resources Prices for Updating"
                    showModal={this.state.isConfirmationModalActive}
                    onCancel={() =>{
                        this.setState({ isConfirmationModalActive: false });
                    }}
                    onSuccess={this.updateResourcePrice}
                    successText="OK"
                >
                    <div className="price-edit-dialog">
                        <p>
                            You are updating the price. Please review and click the OK button if
                            everything is correct, otherwise click the Cancel
                            button.
                        </p>
                        <div>
                            {Object.entries(this.state.updatedPrice).map(([key, obj]) =>
                                ( obj.value
                                    && <div key={key} className="price-list">
                                        <span className="price-name">
                                            {obj.name}
                                        </span>
                                        <span className="price-value">
                                            {obj.value}
                                        </span>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </ModalDialog>
                <ModalDialog
                    title="Batch ID Information"
                    showModal={this.state.isBatchCompleteModalActive}
                    onSuccess={() => {
                        this.setState({ isBatchCompleteModalActive: false });
                        this.props.refreshSearch();
                    }}
                    showCloseControls={false}
                    showCancel={false}
                    successText="OK">
                    <div className="modal-body">
                        <div className="m-2">
                            {TEXT_TYPES.UPLOAD_BATCH_INFO_MSG} {this.state.batchId}.{" "}
                            <Link to="/price-update-status">
                                <b>{TEXT_TYPES.VIEW_STATUS_MSG}</b>
                            </Link>
                        </div>
                    </div>
                </ModalDialog>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/ContentManagement/PriceUpdate.js